import React from "react";
import { Field, FieldArray } from "formik";
import { TextField } from "formik-material-ui";
import NumberFormat from "react-number-format";
import { IconButton, DeleteIcon, Button, Divider, AddCircleOutlineOutlinedIcon, Grid, SearchSelect, makeStyles } from "../../../../"; // import { TextField as  } from "material-ui/TextField";

import { default as MUITextField } from "@material-ui/core/TextField";
import selects from "../../../../assets/selects";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "wrap",
      "justify-content": "flex-start",
      "align-items": "baseline"
    },
    mh35: {
      "min-height": "35vh"
    },
    button: {
      width: "20px",
      "min-width": "20px"
    },
    mr30: {
      "margin-right": "15px"
    },
    options: {
      display: "flex",
      "align-items": "center",
      "justify-content": "space-evenly"
    },
    isMandatory: {
      margin: 0
    },
    w30: {
      width: "23%"
    },
    w5: {
      width: "5%"
    },
    w10: {
      width: "10%"
    },
    minw12: {
      "min-width": "13%"
    }
  };
});

var DocumentItems = function DocumentItems(props) {
  // console.log("DocumentItems props", props);
  var values = props.values,
      mode = props.mode,
      translation = props.translation,
      paymentMethods = props.paymentMethods,
      projects = props.projects,
      franchise = props.franchise;
  var classes = useStyles();
  return [/*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.root
  }, /*#__PURE__*/React.createElement(FieldArray, {
    name: "items",
    render: function render(_ref) {
      var insert = _ref.insert,
          remove = _ref.remove,
          push = _ref.push;
      return values.items && values.items.length > 0 ? values.items.map(function (field, index) {
        return /*#__PURE__*/React.createElement(Grid, {
          item: true,
          md: 12,
          className: classes.root,
          key: index
        }, /*#__PURE__*/React.createElement(Field, {
          name: "items[".concat(index, "].name"),
          component: TextField,
          placeholder: translation ? translation.inputs.items.name : "Concept",
          label: translation ? translation.inputs.items.name : "Concept",
          variant: "outlined",
          className: [classes.mr30, classes.w30].join(" "),
          disabled: mode === "view"
        }), /*#__PURE__*/React.createElement(Field, {
          name: "items[".concat(index, "].description"),
          component: TextField,
          placeholder: translation ? translation.inputs.items.description : "Description",
          label: translation ? translation.inputs.items.description : "Description",
          className: classes.mr30,
          variant: "outlined",
          disabled: mode === "view"
        }), /*#__PURE__*/React.createElement(Field, {
          name: "items[".concat(index, "].qty"),
          placeholder: translation ? translation.inputs.items.quantity : "Quantity",
          label: translation ? translation.inputs.items.quantity : "Quantity",
          component: TextField,
          type: "number",
          variant: "outlined",
          className: [classes.mr30, classes.w5].join(" "),
          disabled: mode === "view"
        }), /*#__PURE__*/React.createElement(Field, {
          name: "items[".concat(index, "].price")
        }, function (_ref2) {
          var field = _ref2.field,
              form = _ref2.form;
          return /*#__PURE__*/React.createElement(NumberFormat, {
            className: [classes.mr30, classes.w10].join(" "),
            disabled: mode === "view",
            name: field.name,
            value: field.value,
            mode: mode,
            placeholder: translation ? translation.inputs.items.price : "Price",
            label: translation ? translation.inputs.items.price : "Price",
            inputmode: "numeric",
            thousandSeparator: ".",
            decimalSeparator: ",",
            variant: "outlined",
            customInput: MUITextField,
            onValueChange: function onValueChange(val) {
              return form.setFieldValue(field.name, val.floatValue);
            }
          });
        }), /*#__PURE__*/React.createElement(Field, {
          name: "items[".concat(index, "].subtotal")
        }, function (_ref3) {
          var field = _ref3.field,
              form = _ref3.form;
          return /*#__PURE__*/React.createElement(NumberFormat, {
            className: [classes.mr30, classes.w10].join(" "),
            name: field.name,
            value: field.value,
            mode: mode,
            disabled: true,
            placeholder: translation ? translation.inputs.items.subtotal : "Subtotal",
            label: translation ? translation.inputs.items.subtotal : "Subtotal",
            inputmode: "numeric",
            thousandSeparator: ".",
            decimalSeparator: ",",
            variant: "outlined",
            customInput: MUITextField,
            onValueChange: function onValueChange(val) {
              return form.setFieldValue(field.name, val.floatValue);
            }
          });
        }), /*#__PURE__*/React.createElement(Field, {
          name: "items[".concat(index, "].tax"),
          component: SearchSelect,
          classNamePrefix: "select",
          placeholder: translation ? translation.selects.taxes.placeholder : "Tax",
          options: translation ? translation.selects.taxes.items : selects.taxes,
          type: "number",
          variant: "outlined",
          className: [classes.minw12, classes.mr30].join(" "),
          disabled: mode === "view"
        }), /*#__PURE__*/React.createElement(Field, {
          name: "items[".concat(index, "].total")
        }, function (_ref4) {
          var field = _ref4.field,
              form = _ref4.form;
          return /*#__PURE__*/React.createElement(NumberFormat, {
            className: [classes.mr30, classes.w10].join(" "),
            name: field.name,
            value: field.value,
            disabled: true,
            placeholder: translation ? translation.inputs.items.total : "Total",
            label: translation ? translation.inputs.items.total : "Total",
            inputmode: "numeric",
            thousandSeparator: ".",
            decimalSeparator: ",",
            variant: "outlined",
            customInput: MUITextField,
            onValueChange: function onValueChange(val) {
              return form.setFieldValue(field.name, val.floatValue);
            }
          });
        }), mode !== "view" && /*#__PURE__*/React.createElement(IconButton, {
          edge: "end",
          "data-cy": "delete",
          color: "secondary",
          onClick: function onClick() {
            return remove(index);
          }
        }, /*#__PURE__*/React.createElement(DeleteIcon, null)), mode !== "view" && index === values.items.length - 1 && /*#__PURE__*/React.createElement(IconButton, {
          onClick: function onClick() {
            return push({
              name: "",
              description: "",
              qty: 1,
              price: 0,
              tax: "",
              total: 0
            });
          },
          edge: "end",
          "data-cy": "add",
          color: "primary"
        }, /*#__PURE__*/React.createElement(AddCircleOutlineOutlinedIcon, null)));
      }) : /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return push({
            concept: "",
            description: "",
            qty: 1,
            price: 0,
            tax: "",
            total: 0
          });
        },
        edge: "end",
        "data-cy": "add",
        color: "primary",
        variant: "outlined"
      }, translation ? translation.buttons.add_item : "Add new item");
    }
  })), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: [classes.root, classes.mh35]
  }, /*#__PURE__*/React.createElement(Field, {
    "data-cy": "message",
    name: "message",
    component: TextField,
    multiline: true,
    rows: "4",
    className: [classes.mr30, classes.w30].join(" "),
    placeholder: translation ? translation.inputs.message : "Message. It would be visible in the invoice",
    label: translation ? translation.inputs.message : "Message. It would be visible in the invoice",
    value: values.message,
    variant: "outlined",
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    "data-cy": "payment_method_id",
    name: "payment_method_id",
    className: [classes.mr30, classes.w30].join(" "),
    component: SearchSelect,
    placeholder: translation ? translation.selects.payment_method.placeholder : "Payment method",
    options: paymentMethods,
    clickable: mode !== "view"
  }), /*#__PURE__*/React.createElement(Field, {
    "data-cy": "category",
    name: "category",
    key: "category",
    className: [classes.mr30, classes.w30].join(" "),
    component: SearchSelect,
    placeholder: translation ? translation.selects.categories.placeholder : "Category",
    options: translation ? translation.selects.categories.items : selects.invoice_categories,
    clickable: mode !== "view"
  }), franchise && /*#__PURE__*/React.createElement(Field, {
    "data-cy": "project",
    name: "project",
    key: "project",
    className: [classes.mr30, classes.w30].join(" "),
    component: SearchSelect,
    placeholder: translation ? translation.selects.projects.placeholder : "Projects",
    options: projects // projects &&
    // projects.filter(
    //   project => project.client && project.client[0] === values.client
    // )
    //info.clients.find(client => client._id === values.client).projects
    ,
    clickable: mode !== "view"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: [classes.root, classes.mh35].join(" ")
  }, /*#__PURE__*/React.createElement(Field, {
    name: "irpf",
    "data-cy": "irpf",
    key: "irpf"
  }, function (_ref5) {
    var field = _ref5.field,
        form = _ref5.form;
    return /*#__PURE__*/React.createElement(NumberFormat, {
      name: field.name,
      value: field.value,
      suffix: "%",
      label: translation ? translation.inputs.irpf : "IRPF",
      placeholder: translation ? translation.inputs.irpf : "IRPF",
      isNumericString: true,
      variant: "outlined",
      customInput: MUITextField,
      onValueChange: function onValueChange(val) {
        return form.setFieldValue(field.name, val.floatValue);
      }
    });
  }))];
};

export { DocumentItems };